// extracted by mini-css-extract-plugin
export default {"root":"_36TS2","variant-horizontal":"d_HkK","variantHorizontal":"d_HkK","title":"_2CxcV","message":"_2KYOZ","core-star":"_EyZM","coreStar":"_EyZM"};